import { createFileRoute } from "@tanstack/react-router";
import { AdminLoginPage } from "@/projects/admin/pages/LoginPage";

export const Route = createFileRoute("/login/admin")({
  head: () => ({
    meta: [{ title: "Admin Login — રાજનગર જ્ઞાનોત્સવ 2.0" }],
  }),
  component: AdminLoginPage,
});
